// extracted by mini-css-extract-plugin
module.exports = {"list":"AgreementPage10_list__3ATT6"};